import React, { useEffect } from 'react'
import styles from './styles.module.css'
import Button from '../../components/Button'
import { IoIosAdd } from 'react-icons/io'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import Modal from './Modal'
import Table from '../../components/Table'
import { BiTrash } from 'react-icons/bi'
import Confirmation from '../../components/Confirmation/Confirmation'
import { getHolidays } from '../../actions/holidays'
import { deleteEducationalInstitutions, getEducationalInstitutions } from '../../actions/educationalInstitutions'


export default function EducationalInstitutions() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { educInstitList } = useSelector(state => state.educational_institutions)

  const [selectedItem, setSelectedItem] = useState(null)
  const [confirmation, setConfirmation] = useState(false);

  useEffect(() => {
    dispatch(getEducationalInstitutions())
  }, [selectedItem])

  const openModal = (data) => () => {
    setSelectedItem(data)
  }

  const closeModal = () => setSelectedItem(null)

  const goHome = () => navigate('/')

  const acceptConfirmation = () => {
    closeModal();
    dispatch(deleteEducationalInstitutions(confirmation.id));
    setConfirmation(false);
  };
  const rejectConfirmation = () => {
    setConfirmation(false);
  };

  const renderLi = (data) => {
    const { idschool, schoolname } = data
    return (
      <tr >
        <td onClick={openModal(data)}>{schoolname}</td>
        <td><i className={styles.trash} onClick={() => setConfirmation({ id: idschool, name: schoolname })}><BiTrash /></i></td>
      </tr>
    )
  }

  return (
    <div className={styles.wrapper} style={{ width: '700px', margin: '0 auto' }}>
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title={`Вы уверены, что хотите удалить ${confirmation.name}?`}
          acceptConfirmation={() => acceptConfirmation(confirmation?.name)}
          rejectConfirmation={rejectConfirmation}
        />
      )}
      {selectedItem &&
        <Modal
          closeModal={closeModal}
          data={selectedItem}
          height={'430px'}
          // addMode={(!selectedItem?.name && selectedItem !== null)}
          addMode={selectedItem == 'add'}
        />
      }
      <h1>Учебные заведения</h1>

      <Table className={styles.tableDis}>
        <thead>
          <tr>

            <th>Название</th>

            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>

          {educInstitList?.map(renderLi)}

        </tbody>
      </Table>

      <div style={{ display: 'flex', flexDirection: "row" }}>
        <Button
          style={{ padding: '.5rem 1.5rem', margin: '12px' }}
          onClick={openModal('add')}
        >
          <IoIosAdd size={30} />
          Добавить
        </Button>
      </div>
    </div>
  )
}
